
export type GetCoursesSortBy = typeof GetCoursesSortBy[keyof typeof GetCoursesSortBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCoursesSortBy = {
  createdAt: 'createdAt',
  title: 'title',
  level: 'level',
  instructorName: 'instructorName',
} as const;
